import Typography from '@mui/material/Typography';
import { useField, useFormikContext } from 'formik';

import { TEXT_REQUIRED_MESSAGE } from '../../utils/forms';

export interface FormikErrorProps {
  /** Name of the field within the parent formik state */
  errorName: string;
  /** Show error even if field has not been touched */
  noTouchCheck?: boolean;
  /** Only show error if there has been a submission attempt */
  submitCheck?: boolean;
  /** Overide formik message with a custom one */
  errorMessage?: string;
}

function FormikError({ errorName, errorMessage, noTouchCheck, submitCheck }: FormikErrorProps) {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const [_, { error: formikError, touched }] = useField<{ [key: string]: unknown }>(errorName);

  const { submitCount } = useFormikContext<{ [key: string]: unknown }>();

  const submitAttempted = submitCheck ? !!submitCount : true;

  const fieldTouchCheck = noTouchCheck ? true : touched;

  const error = formikError
    ? errorMessage ?? (errorName === 'location' ? TEXT_REQUIRED_MESSAGE : formikError)
    : undefined;

  if (typeof error !== 'string' || !fieldTouchCheck || !submitAttempted) return null;

  // Dirty hack necessary because without it validation fails with a very strange error:
  //
  // Error: Objects are not valid as a React child (found: object with keys {postcode, locality}).
  // If you meant to render a collection of children, use an array instead.
  return (
    <Typography color="error" variant="subtitle1">
      {error}
    </Typography>
  );
}

export default FormikError;
